var pug = require("!../../../../devtools/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cloader ng-if=\"$ctrl.showLoader\"\u003E\u003C\u002Floader\u003E\u003Caktualis-arfolyam-tabla ng-show=\"!$ctrl.showLoader &amp;&amp; !$ctrl.notEnoughData\" aktualis=\"$ctrl.aktualisArfolyam\"\u003E\u003C\u002Faktualis-arfolyam-tabla\u003E\u003Cdiv ng-show=\"$ctrl.notEnoughData\"\u003ENincs adat.\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ../source/application/aktualis-arfolyamok/aktualis-arfolyamok/aktualis-arfolyamok.pug
// module id = 593
// module chunks = 8